module.exports = __webpack_public_path__ + "img/lock-shield-generic.c8dce0b.webp";